const Home = {
  text: 'Home',
  link: '/home',
  icon: 'icon-home'
};

const Requests = {
  text: 'Requests',
  link: '/requests',
  icon: 'icon-note',
  submenu: [
    {
      text: 'My Requests',
      link: '/requests/my-requests'
    },
    {
      text: 'Team Requests',
      link: '/requests/team-requests'
    }
  ],
  isRole: ['DPAM_PROCESS_REQUEST']
};

const Search = {
  text: 'Search',
  link: '/dpam-search',
  icon: 'icon-magnifier'
};

const New = {
  text: 'New',
  link: '/product',
  icon: 'icon-plus',
  isRole: ['DPAM_PROCESS_REQUEST']
};

const NewGroup = {
  text: 'New Group',
  link: '/product-group',
  icon: 'icon-layers',
  isRole: ['DPAM_PROCESS_REQUEST']
};

const RequestsMetrics = {
  text: 'Requests Metrics',
  link: '/requests-metrics',
  icon: 'icon-chart',
  isRole: ['DPAM_PROCESS_REQUEST']
};

const Profile = {
  text: 'Profile',
  link: '/profile',
  icon: 'icon-settings',
  isRole: ['DPAM_PROCESS_REQUEST']
};

const Bulletin = {
  text: 'Bulletin',
  link: '/bulletin',
  icon: 'icon-list',
  isRole: ['DPAM_ADMIN']
};

const userMenu = {
  text: 'DPAM',
  heading: true
};

const metricsMenu = {
  text: 'Metrics',
  heading: true,
  isRole: ['DPAM_PROCESS_REQUEST']
};

const adminMenu = {
  text: 'Settings',
  heading: true,
  isRole: ['DPAM_PROCESS_REQUEST']
};


export const menu = [
    userMenu,
    Home,
    // Requests,
    // Search,
    // New,
    // NewGroup,
    //
    // metricsMenu,
    // RequestsMetrics,
    //
    // adminMenu,
    // Profile,
    // Bulletin
];
